export default function () {
  const widgetName = 'activitiesWidget';
  const widgetOpts = activitiesWidgetOpts;

  function addClassesByIndex(widget, index) {
    const adjustedIndex = index + 1;
    if (adjustedIndex % 2 === 1) {
      $(widget[index]).addClass('white');
    } else {
      $(widget[index]).addClass('green');
    }
  }

  // Function to iterate through widgets and add classes accordingly
  function iterateWidgets(widget, classFunction) {
    widget.each((index) => {
      classFunction(widget, index);
    });
  }

  // Main function for organizing activities
  function organizeActivities() {
    const activities = $(`#${widgetName}`);
    const items = activities.find('.card-widget-item');

    // Slicing items into rows
    const rows = [];
    for (let i = 0; i < items.length; i += 4) {
      rows.push(items.slice(i, i + 4));
    }

    // Adding 'button' class to buttons
    const buttons = activities.find('.buttonwrap a');
    console.log('hola')
    buttons.each((i, button) => {
      $(button).addClass('button');
    });

    // Iterating through rows and applying classes
    rows.forEach((row, index) => {
      if (index % 2 === 0) {
        iterateWidgets(row, addClassesByIndex);
      } else {
        iterateWidgets(row, (widget, index) => {
          addClassesByIndex(widget, index);
        });
      }
    });
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function () {
      // Function to add classes based on index parity
      const activities = $(`#${widgetName}`);
      const items = activities.find('.card-widget-item');
      const itemsFirstRow = items.slice(0, 4);
      const itemsSecondRow = items.slice(4, 8);
      const itemsThirdRow = items.slice(8, 12);
      // create an array of Rows
      const rows = [itemsFirstRow, itemsSecondRow, itemsThirdRow];

      const buttons = activities.find('.buttonwrap a');

      buttons.each((i, button) => {
        $(button).addClass('button');
      });
      function pairClasses(widget) {
        widget.each((index) => {
          const adjustedIndex = index + 1;
          // if adjustedIndex % 2 then add class green
          if (adjustedIndex % 2) {
            $(widget[index]).addClass('white');
          } else {
            $(widget[index]).addClass('green');
          }
        });
      }
      function reverseClasses(widget) {
        widget.each((index) => {
          const adjustedIndex = index + 1;
          // if adjustedIndex % 2 then add class green
          if (adjustedIndex % 2) {
            $(widget[index]).addClass('green');
          } else {
            $(widget[index]).addClass('white');
          }
        });
      }
      // iterate each row and apply the pairClasses function when the row is odd and reverseClasses when the row is even
      rows.forEach((row, index) => {
        if (index % 2) {
          pairClasses(row);
        } else {
          reverseClasses(row);
        }
      });
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 12,
    moreButton: {
      visible: true,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
